export default __webpack_public_path__ + "static/media/salma.a2118679.png";